/* eslint-disable */
import * as Types from '../../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WizardPreviewDataQueryVariables = Types.Exact<{
  params: Types.Scalars['JSON']['input'];
}>;


export type WizardPreviewDataQuery = { agentViewData: { __typename: 'AgentViewDataResult', data: any } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };


export const WizardPreviewDataDocument = gql`
    query WizardPreviewData($params: JSON!) {
  agentViewData(component: "wizard_preview", params: $params) {
    __typename
    ... on AgentViewDataResult {
      data
    }
  }
}
    `;

/**
 * __useWizardPreviewDataQuery__
 *
 * To run a query within a React component, call `useWizardPreviewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useWizardPreviewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWizardPreviewDataQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useWizardPreviewDataQuery(baseOptions: Apollo.QueryHookOptions<WizardPreviewDataQuery, WizardPreviewDataQueryVariables> & ({ variables: WizardPreviewDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WizardPreviewDataQuery, WizardPreviewDataQueryVariables>(WizardPreviewDataDocument, options);
      }
export function useWizardPreviewDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WizardPreviewDataQuery, WizardPreviewDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WizardPreviewDataQuery, WizardPreviewDataQueryVariables>(WizardPreviewDataDocument, options);
        }
export function useWizardPreviewDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WizardPreviewDataQuery, WizardPreviewDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WizardPreviewDataQuery, WizardPreviewDataQueryVariables>(WizardPreviewDataDocument, options);
        }
export type WizardPreviewDataQueryHookResult = ReturnType<typeof useWizardPreviewDataQuery>;
export type WizardPreviewDataLazyQueryHookResult = ReturnType<typeof useWizardPreviewDataLazyQuery>;
export type WizardPreviewDataSuspenseQueryHookResult = ReturnType<typeof useWizardPreviewDataSuspenseQuery>;
export type WizardPreviewDataQueryResult = Apollo.QueryResult<WizardPreviewDataQuery, WizardPreviewDataQueryVariables>;